module.exports = {
  path: ':reference/extend',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MyBookingExtend'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_bookings/routes/extend/index.js